module.exports = __webpack_public_path__ + "img/logo.fe17b24f.png";